import { render, staticRenderFns } from "./PublicTicketView.vue?vue&type=template&id=49c880e8&scoped=true"
import script from "./PublicTicketView.vue?vue&type=script&lang=js"
export * from "./PublicTicketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c880e8",
  null
  
)

export default component.exports